import { useQuery } from '@tanstack/react-query';
import { getClientDirectory } from '../klantenlijst.api';

const KLANTENLIJST_QUERY_KEY = ['processes', 'klantenlijst'] as const;

/**
 * Story 1 van spec-klant-zoeken-op-naam: de namen worden hergebruikt zolang het scherm open staat,
 * dus één ophaalactie per sessie in plaats van één per toetsaanslag.
 *
 * `enabled`: de tabelfilters vragen de lijst alleen op als een kolom erom vraagt; `/clients/directory`
 * is alleen voor interne rollen (spec-tabelfilters §2).
 */
export function useKlantenlijst(enabled = true) {
  return useQuery({
    queryKey: KLANTENLIJST_QUERY_KEY,
    queryFn: () => getClientDirectory(),
    staleTime: Infinity,
    enabled,
  });
}
